import ClickOutside from 'vue-click-outside';
import { isMobile } from 'utils/general';
import { i18n } from 'lib/i18n.js';

export default {
  props: ['choices', 'menuLabel', 'selected'],
  i18n,
  data: function () {
    return {
      opened: false,
      selectedIndex: 0,
      description: this.selected.description,
    };
  },
  watch: {
    selected(_new, _old) {
      if(_new != _old) {
        this.selectedIndex = this.choices.findIndex(
          (el) => el.label === this.selected.label,
        );
      }
    }
  },
  directives: {
    ClickOutside,
  },
  mounted() {
    this.selectedIndex = this.choices.findIndex(
      (el) => el.label === this.selected.label,
    );
  },
  computed: {
    containerHeight() {
      return this.$refs.container.offsetHeight;
    },
    triggerId() {
      return 'dropdown-custom__selection--' + this.menuLabel;
    },
    ariaControls() {
      return 'dropdown-custom__options--' + this.menuLabel;
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
      if (this.opened) {
        this.$el.focus();
      }
    },
    makeSelection(selected, closeSelect = true) {
      this.$emit('change', selected);
      this.description = selected.description;
      this.selectedIndex = this.choices.findIndex(
        (el) => el.value === selected.value,
      );

      this.$nextTick(() => {
        if (!isMobile()) {
          const list = this.$refs.container.querySelector(
            '#dropdown-custom__options',
          );

          const listItem = list.querySelector('li[aria-selected="true"]');
          listItem.focus();
          const listItemHeight = listItem.offsetHeight;
          list.scroll({ top: this.selectedIndex * listItemHeight });
        }
      });

      if (closeSelect) {
        this.opened = false;
      }
    },
    close() {
      this.opened = false;
    },
    handleKeyboardNavigation(e) {
      switch (e.keyCode) {
        case 38: //arrow up
          e.preventDefault();

          this.makeSelection(
            this.selectedIndex === 0
              ? this.choices[this.choices.length - 1]
              : this.choices[this.selectedIndex - 1],
            false,
          );
          break;
        case 40: //arrow down
          e.preventDefault();

          this.makeSelection(
            this.selectedIndex === this.choices.length - 1
              ? this.choices[0]
              : this.choices[this.selectedIndex + 1],
            false,
          );
          break;
        case 9: //Tab
          this.close();
          break;
        case 27: //Esc
          this.close();
          break;
      }
    },
  },
  template: `
    <div class="dropdown-custom__container" v-click-outside="close" ref="container">
      <div class="label sr-only" :id="menuLabel">{{ $t('products.product.select_option') }}</div>

      <button class="dropdown-custom__selection"
        role="combobox"
        aria-haspopup="listbox"
        :aria-labelledby="menuLabel"
        :class="{'opened': opened}"
        :id="triggerId"
        @click="toggle"
        @keydown="handleKeyboardNavigation"
        :aria-expanded="[opened ? 'true' : 'false']"
        :aria-controls="ariaControls"
        :aria-label="description"
        :aria-activedescendant="selectedIndex"
      >
        <div class="dropdown-custom__selection-text">
          <span class="dropdown-custom__selection-text__text" v-html="selected.label"></span>
          <span class="dropdown-custom__arrow"></span>
        </div>
      </button>
      <transition name="grow">
        <ul class="dropdown-custom__options"
          :id="ariaControls"
          :aria-labelledby="triggerId"
          v-if="opened"
          :style="{ top: containerHeight + 'px' }"
          role="listbox"
          @keydown="handleKeyboardNavigation"
          >
          <li
            class="dropdown-custom__options__option"
            role="option"
            v-for="(option, i) in choices"
            v-html="option.label"
            :aria-selected="i == selectedIndex ? 'true' : 'false'"
            :key="i"
            :id="option.value.replace(/\W+/g, '_') + '--' + menuLabel"
            @click="makeSelection(option)"
            @keyup.enter="makeSelection(option)"
            :aria-label="description"
            tabindex="0"
            >
          </li>
        </ul>
      </transition>
    </div>
  `,
};
